module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('i', [_vm._v("The following abbreviations are used in the text:")])]), _vm._v(" "), _c('p', {
    staticClass: "bigspace"
  }), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "5pt"
    }
  }, [_c('b', [_vm._v("Tanakh (Old Covenant):")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Genesis (Gen.)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Psalms (Ps.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Exodus (Exod.)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Proverbs (Prov.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Leviticus (Lev.)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Isaiah (Isa.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Numbers (Num.)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Jeremiah (Jer.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Deuteronomy (Deut.)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Ezekiel (Ezek.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Joshua (Josh.)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Hosea (Hos.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("1 Samuel (1 Sam.)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Zechariah (Zech.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("2 Samuel (2 Sam)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Malachi (Mal.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Nehemiah (Neh.)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "5pt",
      "margin-top": "40pt"
    }
  }, [_c('b', [_vm._v("Brit Chadasha (New Covenant):")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Matthew (Matt.)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Philippians (Phil.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Acts of the Apostles (Acts)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Colossians (Col.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Romans (Rom.)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("2 Timothy (2 Tim)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("1 Corinthians (1 Cor.)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Hebrews (Heb.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("2 Corinthians (2 Cor.)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("1 Peter (1 Pet.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Galatians (Gal.)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Revelation (Rev.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Ephesians (Eph.)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "bigspace"
  }), _c('p', {
    staticClass: "noind"
  }, [_c('b', [_vm._v("Talmud:")])]), _vm._v(" "), _c('p', {
    staticClass: "smallspace"
  }), _c('p', {
    staticClass: "noind"
  }, [_vm._v("First order: Seeds")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Berakhot")]), _vm._v(" ("), _c('i', [_vm._v("Ber")]), _vm._v(".)—Blessings: laws relating to prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Second order: Seasons")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Shabbat")]), _vm._v(" ("), _c('i', [_vm._v("Shab")]), _vm._v(".)—Sabbath: most of the laws governing the Sabbath.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Pesachim")]), _vm._v(" ("), _c('i', [_vm._v("Pes")]), _vm._v(".)—Paschal Offerings: the laws concerning Passover.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Yoma")]), _vm._v("—the Day: concerning "), _c('i', [_vm._v("Yom Kippur")]), _vm._v(" (Day of Atonement).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Sukkah")]), _vm._v(" ("), _c('i', [_vm._v("Sukk")]), _vm._v(".)—Booth: concerning the Festival of "), _c('i', [_vm._v("Sukkot")]), _vm._v(" (Tabernacles).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Megillah")]), _vm._v(" ("), _c('i', [_vm._v("Meg")]), _vm._v(".)—Scroll: concerning the writing and public reading of Torah, the Prophets, and the scroll of Esther.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Third Order: Women")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Nedarim")]), _vm._v(" ("), _c('i', [_vm._v("Ned")]), _vm._v(".)—Vows: laws concerning vows.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Sotah")]), _vm._v(" ("), _c('i', [_vm._v("Sot")]), _vm._v(".)—A woman suspected of adultery: how to deal with such a case; also concerning the Priestly Benediction.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Kiddushin")]), _vm._v(" ("), _c('i', [_vm._v("Kidd")]), _vm._v(".)—Betrothals: laws governing the betrothal relationship.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Fourth Order: Torts")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Avot")]), _vm._v(" ("), _c('i', [_vm._v("Av")]), _vm._v(".)—Fathers: a compilation of the sayings of various sages.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Fifth Order: Sanctities")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("Menahot")]), _vm._v(" ("), _c('i', [_vm._v("Men")]), _vm._v(".)—Meal-offerings: concerning cereal offerings; also concerning "), _c('i', [_vm._v("tzitzit")]), _vm._v(" and "), _c('i', [_vm._v("tefillin.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a9f7664","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_abbreviations.vue
// module id = 81
// module chunks = 0